import { STATIC_FIELD_NAMES, StaticFieldDescriptorsMap } from '../../fields/StaticField/constants';
import type { APIField } from '../../fields/types/main';
import type { FieldDescriptor, FieldParseReturnValue } from '../../fields/types/common';

const defaultParseFieldResponse: FieldDescriptor<any>['parseFieldResponse'] = ({
  field,
  fieldKey,
}): FieldParseReturnValue => [
  {
    key: fieldKey,
    type: field.type,
    data: field,
  },
];

export const parseFieldResponse = (field: APIField, fieldKeyPrefix = ''): FieldParseReturnValue => {
  const fieldKey = `${fieldKeyPrefix}${field.key}`;

  if (field.type === 'DynamicField' || field.type === 'DynamicFields') {
    return [
      {
        type: field.type,
        ...field,
        key: fieldKey,
      },
    ];
  }

  if (STATIC_FIELD_NAMES.includes(field.type)) {
    const fieldDescriptor = StaticFieldDescriptorsMap[field.type];

    const fieldParser = fieldDescriptor?.parseFieldResponse ?? defaultParseFieldResponse;
    return fieldParser({ field, fieldKey, parse: parseFieldResponse });
  }

  return null;
};
